import script from "./RouteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteButton.vue?vue&type=script&setup=true&lang=js"

import "./RouteButton.vue?vue&type=style&index=0&id=cf72bc1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf72bc1c"]])

export default __exports__